/** Marks dashboard diagnostics stale after subscription/search lifecycle changes. */
let diagnosticsStale = false;

export function markDiagnosticsStale(): void {
  diagnosticsStale = true;
}

export function consumeDiagnosticsStale(): boolean {
  if (!diagnosticsStale) return false;
  diagnosticsStale = false;
  return true;
}
